<template>
  <svg
    class="app-spinner-icon"
    :class="sizeClass"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle class="app-spinner-icon-track" cx="12" cy="12" r="9"></circle>
    <path class="app-spinner-icon-head" d="M12 3a9 9 0 0 1 9 9"></path>
  </svg>
</template>

<script setup>
const props = defineProps({
  size: {
    type: String,
    default: 'md'
  }
})

const sizeClass = `is-${props.size}`
</script>

<style scoped>
.app-spinner-icon {
  display: inline-block;
  color: inherit;
  animation: app-spinner-icon-spin 0.9s linear infinite;
}

.app-spinner-icon.is-sm {
  width: 14px;
  height: 14px;
}

.app-spinner-icon.is-md {
  width: 16px;
  height: 16px;
}

.app-spinner-icon.is-lg {
  width: 20px;
  height: 20px;
}

.app-spinner-icon-track {
  fill: none;
  stroke: rgba(116, 143, 171, 0.2);
  stroke-width: 2.25;
}

.app-spinner-icon-head {
  fill: none;
  stroke: currentColor;
  stroke-width: 2.25;
  stroke-linecap: round;
}

@keyframes app-spinner-icon-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
